import {
    ADD_NEXT_BILLS,
    GET_CHEQUE,
    ADD_NEXT_PAYMENTS,
    GET_REQUEST_CHEQUE,
    RENAME_PAYMENT,
    UPDATE_RECORDS,
    UPDATE_REQUEST_BY_FILTER,
    SET_HISTORY,
} from 'actions/historyAction';

import update from 'immutability-helper';

const history = (state = {}, action = {}) => {
    let mergeState;
    let isFound = false;
    let paymentArrayIndex = 0;
    let recordArrayIndex = 0;
    let newRecord;
    let newRecords;
    let dataPayments;
    let dataBills;
    switch (action.type) {
        case SET_HISTORY:
            mergeState = update(state, {
                paymentHistory: { $set: action.extra.paymentHistory },
                billHistory: { $set: action.extra?.billHistory },
                email: { $set: action.extra?.email },
                showSpecialEmailPromoCode: { $set: action.extra?.showSpecialEmailPromoCode },
            });
            break;
        case ADD_NEXT_PAYMENTS:
            dataPayments = action.paymentHistory.payments;
            if (Array.isArray(dataPayments) && dataPayments[0] && Array.isArray(dataPayments[0].records) && dataPayments[0].records[0]) {
                const statePayments = [...state.paymentHistory.payments];
                const lastStatePayments = statePayments[statePayments.length - 1].records;
                const lastStateDate = lastStatePayments[0].submitDate;
                const firstDataDate = dataPayments[0].records[0].submitDate;
                if (lastStateDate.year === firstDataDate.year && lastStateDate.monthValue === firstDataDate.monthValue) {
                    statePayments[statePayments.length - 1].records = lastStatePayments.concat(dataPayments[0].records);
                    const newDataRecords = dataPayments.splice(1, dataPayments.length);
                    newRecords = statePayments.concat(newDataRecords);
                } else {
                    newRecords = statePayments.concat(dataPayments);
                }
                mergeState = update(state, {
                    paymentHistory: {
                        lastPaymentId: { $set: action.paymentHistory.lastPaymentId },
                        payments: { $set: newRecords },
                    },
                });
            } else {
                mergeState = update(state, {
                    paymentHistory: {
                        lastPaymentId: { $set: action.paymentHistory.lastPaymentId },
                    },
                });
            }
            break;
        case ADD_NEXT_BILLS:
            dataBills = action.billHistory.bills;
            if (dataBills && dataBills[0]?.records[0]) {
                const stateBills = [...state.billHistory.bills];
                const lastStateBills = stateBills[stateBills.length - 1].records;
                const lastStateDate = lastStateBills[0].createDate;
                const firstDataDate = dataBills[0].records[0].createDate;
                if (lastStateDate.year === firstDataDate.year && lastStateDate.monthValue === firstDataDate.monthValue) {
                    stateBills[stateBills.length - 1].records = lastStateBills.concat(dataBills[0].records);
                    const newDataRecords = dataBills.splice(1, dataBills.length);
                    newRecords = stateBills.concat(newDataRecords);
                } else {
                    newRecords = stateBills.concat(dataBills);
                }
                mergeState = update(state, {
                    billHistory: {
                        lastBillId: { $set: action.billHistory.lastBillId },
                        bills: { $set: newRecords },
                    },
                });
            } else {
                mergeState = update(state, {
                    billHistory: {
                        lastBillId: { $set: action.billHistory.lastBillId },
                    },
                });
            }
            break;
        case UPDATE_REQUEST_BY_FILTER:
            mergeState = update(state, {
                billHistory: { $set: action.paymentHistory },
            });
            break;
        case GET_CHEQUE:
            mergeState = update(state, {
                cheque: { $set: { isSend: true, ...action.cheque } },
            });
            break;
        case GET_REQUEST_CHEQUE:
            state.billHistory.bills.map((records, billRecordsIndex) => {
                if (!isFound) {
                    paymentArrayIndex = billRecordsIndex;
                    records.records.map((record, billIndex) => {
                        if (!isFound) {
                            recordArrayIndex = billIndex;
                            if (record.id === action.cheque?.cheque?.id) {
                                isFound = true;
                                newRecord = { ...record };
                                newRecord.newBill = false;
                            }
                        }
                    });
                }
            });
            mergeState = update(state, {
                cheque: { $set: { isRequest: true, ...action.cheque } },
                billHistory: { bills: { [paymentArrayIndex]: { records: { [recordArrayIndex]: { $set: newRecord } } } } },
            });
            break;
        case RENAME_PAYMENT:
            state.paymentHistory.payments.map((records, paymentIndex) => {
                if (!isFound) {
                    paymentArrayIndex = paymentIndex;
                    records.records.map((record, recordIndex) => {
                        if (!isFound) {
                            recordArrayIndex = recordIndex;
                            if (record.paymentId === action.paymentId) {
                                isFound = true;
                                newRecord = { ...record };
                                newRecord.toProviderName = action.name;
                            }
                        }
                    });
                }
            });
            mergeState = update(state, {
                cheque: {
                    toProviderName: { $set: action.name },
                },
                paymentHistory: {
                    payments: {
                        [paymentArrayIndex]: {
                            records: {
                                [recordArrayIndex]: { $set: newRecord },
                            },
                        },
                    },
                },
            });
            break;
        case UPDATE_RECORDS:
            mergeState = update(state, {
                paymentHistory: {
                    payments: {
                        [action.paymentIndex]: {
                            records: {
                                [action.recordIndex]: { $set: action.newRecord },
                            },
                        },
                    },
                },
            });
            break;
        default:
            return state;
    }

    return mergeState;
};
export default history;
